import { createFileRoute } from '@tanstack/react-router';

import { ScriptsPlanning } from '@/view/pages/ScriptsPlanning';

export const Route = createFileRoute('/_protected/$programId/planejamento-de-roteiros')({
  component: ScriptsPlanning,
  context: (context): { title: string } => ({
    ...context,
    title: 'Planejamento de Roteiros',
  }),
});
